import { render, staticRenderFns } from "./PillBadgeContextual.vue?vue&type=template&id=06c0f95f"
import script from "./PillBadgeContextual.vue?vue&type=script&lang=js"
export * from "./PillBadgeContextual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports